// extracted by mini-css-extract-plugin
module.exports = {"archiveContainer":"teamInbox_archiveContainer__zzl3B","threadContainer":"teamInbox_threadContainer__16UwS","hide":"teamInbox_hide__1tnfr"};